export default "__VITE_ASSET__DVC5LFi3__"